export const isEnterKey = (event) => event.key === 'Enter'
export const isSpaceKey = (event) => event.key === ' '
export const isBackspaceKey = (event) => event.key === 'Backspace'
export const isTabKey = (event) => event.key === 'Tab'
export const isCommaKey = (event) => event.key === ',' || event.key === 'Comma'
export const isEscapeKey = (event) => event.key === 'Escape'
export const isArrowDownKey = (event) => event.key === 'ArrowDown'
export const isArrowUpKey = (event) => event.key === 'ArrowUp'
